import React from "react";
import { renderDate } from "../../helpers/Date";
import SupportChangesTableCell from "./SupportChangesTableCell";
import {
  renderStartDate,
  renderMonth,
  renderDollars,
  renderNumber,
  renderName,
} from "../../helpers/renderCells";
import reportTypes from "./reportTypes";

const SupportTableColumns = (reportType) => {
  const Supporter = {
    Header: "Financial Partners",
    accessor: "lastname",
    sticky: "left",
    Cell: (cell) => renderName(cell),
  };

  const Fullname = {
    Header: "Financial Partners",
    accessor: "fullname",
    sticky: "left",
    Cell: (cell) => renderName(cell),
  };

  const Change = {
    Header: "Change",
    accessor: "status",
    Cell: (cell) => <SupportChangesTableCell cell={cell} />,
  };

  const Modified = {
    Header: "Modified",
    accessor: "date_modified",
    Cell: (cell) => renderDate(cell.value),
  };

  const Start = {
    Header: "Start",
    accessor: "date_created",
    Cell: (cell) => renderStartDate(cell),
  };

  const Method = {
    Header: "Method",
    accessor: "method",
    Cell: (cell) => {
      const find = [
        "WBC Bank Statement",
        "Direct Deposit",
        "FB-Journl",
        "Journal",
      ];
      const replace = [
        "Bank Deposit",
        "Bank Deposit",
        "Fringe Benefits",
        "Internal Transfer",
      ];

      return find.reduce(
        (acc, curr, index) =>
          acc.replace(new RegExp(curr, "g"), replace[index]),
        cell.value
      );
    },
  };

  const MonthDue = {
    Header: "Month Due",
    accessor: "date_next_debit",
    Cell: (cell) => renderMonth(cell.value),
  };

  const LastDeposit = {
    Header: "Last Deposit",
    id: "last_deposit",
    columns: [
      {
        Header: "Date",
        accessor: "date_last_deposit",
        Cell: (cell) => renderDate(cell.value, true),
      },
      {
        Header: "Amount",
        accessor: "amount_last_deposit",
        Cell: (cell) => renderDollars(cell.value),
      },
    ],
  };

  const Frequency = {
    Header: "Frequency",
    accessor: "frequency",
  };

  const Amount = {
    Header: "Amount",
    accessor: "amount",
    Cell: (cell) => renderDollars(cell.value),
  };

  const lastTwentyFourMonths = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const now = new Date();

    const pastMonths = {};

    for (let count = 1; count <= 24; count += 1) {
      const past = new Date(now.getFullYear(), now.getMonth() - count, 1);
      const month = months[past.getMonth()];
      const year = past.getFullYear().toString();
      const col = {
        Header: `${month}`,
        accessor: `${month}-${year}`,
        Cell: (cell) => renderNumber(cell.value),
      };
      if (pastMonths[year]) {
        pastMonths[year].push(col);
      } else {
        pastMonths[year] = [].concat(col);
      }
    }

    const pastYears = [];

    Object.entries(pastMonths)
      .reverse()
      .map((pastYear) => {
        pastYears.push({
          Header: pastYear[0],
          id: pastYear[0],
          columns: pastYear[1],
          style: { flex: `0 0 ${80 * pastYear[1].length}px` },
        });
      });

    return pastYears;
  };

  let columns = [];

  switch (reportType) {
    case reportTypes.changes:
      columns = [
        Supporter,
        Change,
        Modified,
        Method,
        MonthDue,
        Frequency,
        Amount,
        LastDeposit,
      ];
      break;
    // case 'Supporter Details Updates':
    //   columns = [Supporter, { Header: 'Date', accessor: 'date_modified' }];
    // break;
    case reportTypes.received:
      columns = [Fullname, lastTwentyFourMonths()];
      break;
    default:
      columns = [
        Supporter,
        Start,
        Method,
        MonthDue,
        Frequency,
        Amount,
        LastDeposit,
      ];
  }

  return columns.flat();
};

export default SupportTableColumns;
